import { createDefaultSession } from '@/contexts/Session/SessionDefault';
import type SessionAction from '@/contexts/Session/SessionAction';
import type SessionType from '@/contexts/Session/SessionType';
import type Member from '@/types/member/member';

export function sessionReducer(
  state: SessionType,
  action: SessionAction
): SessionType {
  switch (action.type) {
    case 'UPDATE_JWT':
      return { ...state, jwt: action.payload };
    case 'UPDATE_MSAL_TOKEN':
      return { ...state, msal: action.payload };
    case 'UPDATE_TOKENS':
      return { ...state, jwt: action.payload[0], msal: action.payload[1] };
    case 'REFRESH_TOKENS':
      if (state.jwt !== action.payload.expectedCurrentIdToken) return state;
      return {
        ...state,
        jwt: action.payload.idToken,
        msal: action.payload.accessToken,
      };
    case 'UPDATE_TEMP_MEMBER_ID':
      return { ...state, tmp_member_id: action.payload };
    case 'CLEAR_DATA':
      return {
        ...state,
        tmp_member_id: null,
        legal_document_acceptances: [],
        member_id: null,
      };
    case 'UPDATE_MEMBER_ID':
      return { ...state, member_id: action.payload };
    case 'ADD_LEGAL_DOCUMENT_ACCEPTANCE': {
      const oldAcceptances = state.legal_document_acceptances;
      const newAcceptance = action.payload;
      const acceptanceMap = new Map<string, typeof newAcceptance>();

      oldAcceptances.forEach((acceptance) => {
        acceptanceMap.set(String(acceptance.type), acceptance);
      });
      acceptanceMap.set(String(newAcceptance.type), newAcceptance);

      return {
        ...state,
        legal_document_acceptances: Array.from(acceptanceMap.values()),
      };
    }
    case 'SET_ME':
      return {
        ...state,
        me: action.payload,
      };
    case 'UPDATE_ME':
      return {
        ...state,
        me: {
          ...state.me,
          ...action.payload,
        } as Member,
      };
    case 'LOG_OUT':
      return createDefaultSession();
    case 'FORCE_UPDATE':
      return {
        ...state,
        ...action.payload,
        timestamp: Date.now(),
      };
    default:
      return state;
  }
}
